let accessTokenGetter = null;

export const registerAccessTokenGetter = (getter) => {
  accessTokenGetter = typeof getter === "function" ? getter : null;
};

export const clearAccessTokenGetter = () => {
  accessTokenGetter = null;
};

const isRecoverableTokenError = (error) => {
  const code = error?.error;
  return code === "login_required" || code === "consent_required" || code === "invalid_grant";
};

export const getAccessTokenForApi = async () => {
  if (!accessTokenGetter) {
    return "";
  }

  try {
    const token = await accessTokenGetter();
    return typeof token === "string" ? token : "";
  } catch (error) {
    if (isRecoverableTokenError(error)) {
      return "";
    }
    throw error;
  }
};
